(() => {
  const FONT = {
    0: '01110 10001 10001 10001 10001 10001 01110', 1: '00100 01100 00100 00100 00100 00100 01110', 2: '01110 10001 00001 00110 01000 10000 11111',
    3: '11110 00001 00001 01110 00001 00001 11110', 4: '10001 10001 10001 11111 00001 00001 00001', 5: '11111 10000 11110 00001 00001 10001 01110',
    6: '00110 01000 10000 11110 10001 10001 01110', 7: '11111 00001 00010 00100 01000 01000 01000', 8: '01110 10001 10001 01110 10001 10001 01110',
    9: '01110 10001 10001 01111 00001 00010 01100', K: '10001 10010 10100 11000 10100 10010 10001', ' ': '000 000 000 000 000 000 000',
    '.': '0 0 0 0 0 0 1', '£': '00110 01001 01000 11100 01000 01000 11111', O: '01110 10001 10001 10001 10001 10001 01110', P: '11110 10001 10001 11110 10000 10000 10000',
    E: '11111 10000 10000 11110 10000 10000 11111', N: '10001 11001 10101 10101 10011 10001 10001', C: '01110 10001 10000 10000 10000 10001 01110', L: '10000 10000 10000 10000 10000 10000 11111',
    B: '11110 10001 10001 11110 10001 10001 11110', G: '01110 10001 10000 10111 10001 10001 01110', S: '01111 10000 10000 01110 00001 00001 11110', D: '11110 10001 10001 10001 10001 10001 11110',
  };
  const motion = !matchMedia('(prefers-reduced-motion: reduce)').matches;

  const dots = (el, text) => {
    const chars = String(text).toUpperCase().split('').filter((c) => FONT[c]);
    const rows = Array.from({ length: 7 }, (_, r) => chars.map((c) => FONT[c].split(' ')[r]).join('0'));
    const cols = rows[0].length;
    el.style.setProperty('--cols', cols);
    el.textContent = '';
    rows.join('').split('').forEach((on, i) => {
      const dot = document.createElement('i');
      if (on === '1') {
        dot.className = 'on';
        dot.style.setProperty('--d', `${(i % cols) * 30}ms`);
      }
      el.append(dot);
    });
  };
  window.lsDots = dots;
  const paintAll = () => {
    document.querySelectorAll('[data-ls-dots]').forEach((el) => {
      if (el.dataset.lsDrawn === el.dataset.lsDots && el.childElementCount) return;
      el.dataset.lsDrawn = el.dataset.lsDots;
      dots(el, el.dataset.lsDots);
    });
  };
  paintAll();
  let paintTimer;
  new MutationObserver(() => {
    clearTimeout(paintTimer);
    paintTimer = setTimeout(paintAll, 60);
  }).observe(document.body, { childList: true, subtree: true });

  const contact = document.querySelector('[data-ls-contact]');
  if (contact) {
    const now = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: 'numeric', hour12: false }).formatToParts(new Date());
    const dayName = now.find((p) => p.type === 'weekday').value;
    const hourNow = Number(now.find((p) => p.type === 'hour').value);
    const dayNo = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(dayName) + 1;
    const isOpen = dayNo < 6 && hourNow >= 8 && hourNow < 16;
    contact.classList.toggle('is-open', isOpen);
    const sign = contact.querySelector('[data-ls-sign]');
    sign.dataset.lsDots = isOpen ? 'OPEN' : 'CLOSED';
    paintAll();
    const signText = contact.querySelector('[data-ls-sign-text]');
    signText.textContent = isOpen ? signText.dataset.open : signText.dataset.closed;
    contact.querySelector(`[data-day="${dayNo}"]`)?.classList.add('is-today');

    const form = contact.querySelector('form');
    if (form) {
      const topic = document.createElement('input');
      topic.type = 'hidden';
      topic.name = 'contact[Topic]';
      topic.value = contact.querySelector('[data-topic][aria-pressed="true"]').dataset.topic;
      form.append(topic);
      contact.querySelectorAll('[data-topic]').forEach((btn) => {
        btn.addEventListener('click', () => {
          contact.querySelectorAll('[data-topic]').forEach((b) => b.setAttribute('aria-pressed', b === btn));
          topic.value = btn.dataset.topic;
        });
      });
      const fields = { email: 'input[name="contact[email]"]', name: 'input[name="contact[name]"]', body: 'textarea' };
      const leds = () => {
        Object.entries(fields).forEach(([key, sel]) => {
          const value = form.querySelector(sel)?.value.trim() || '';
          const ok = key === 'email' ? /.+@.+\..+/.test(value) : value.length > 0;
          contact.querySelector(`[data-led="${key}"]`)?.classList.toggle('is-on', ok);
        });
      };
      form.addEventListener('input', leds);
      leds();
    }
  }

  const reveal = document.querySelectorAll('.ls-strip, .ls-glow-in, .blog-post-item');
  if (motion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-lit');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.2 });
    reveal.forEach((el) => io.observe(el));
  } else {
    reveal.forEach((el) => el.classList.add('is-lit'));
  }

  const phone = document.querySelector('[data-ls-phone-led]');
  if (phone) {
    const now = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: 'numeric', hour12: false }).formatToParts(new Date());
    const day = now.find((p) => p.type === 'weekday').value;
    const hour = Number(now.find((p) => p.type === 'hour').value);
    const open = !['Sat', 'Sun'].includes(day) && hour >= 8 && hour < 16;
    phone.classList.toggle('is-open', open);
    phone.title = open ? phone.dataset.open : phone.dataset.closed;
  }

  const read = document.querySelector('[data-ls-read]');
  const body = document.querySelector('.blog-post-content');
  if (read && body) {
    const head = document.querySelector('header-component');
    const update = () => {
      if (head) read.style.top = `${head.getBoundingClientRect().bottom}px`;
      const r = body.getBoundingClientRect();
      const done = Math.min(1, Math.max(0, -r.top / (r.height - innerHeight || 1)));
      read.style.setProperty('--p', done);
    };
    addEventListener('scroll', update, { passive: true, capture: true });
    addEventListener('resize', update);
    update();
  }

  const help = document.querySelector('[data-ls-help]');
  if (help) {
    const rules = { lumen: /lumen|luminous flux/i, cri: /colou?r rendering|\bcri\b/i, beam: /beam/i, ip: /\bip\b|ingress/i, kelvin: /colou?r temp|kelvin|\bcct\b/i, efficacy: /efficacy|lm\/w/i };
    help.querySelectorAll(':scope > div').forEach((row, i) => {
      const dt = row.querySelector('dt');
      const key = Object.keys(rules).find((k) => rules[k].test(dt.textContent));
      if (!key) return;
      const note = document.createElement('dd');
      note.className = 'ls-help__text';
      note.id = `LsHelp${i}`;
      note.hidden = true;
      note.textContent = help.dataset[key];
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ls-help';
      btn.textContent = '?';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', note.id);
      btn.setAttribute('aria-label', `${help.dataset.what} ${dt.textContent.trim()}`);
      btn.addEventListener('click', () => {
        note.hidden = !note.hidden;
        btn.setAttribute('aria-expanded', !note.hidden);
      });
      dt.append(' ', btn);
      row.append(note);
    });
  }

  const stops = [[2700, [255, 176, 90]], [4000, [255, 233, 194]], [6500, [200, 220, 255]]];
  const mix = (k) => {
    k = Math.min(6500, Math.max(2700, k));
    const i = k < 4000 ? 0 : 1;
    const [a, ca] = stops[i];
    const [b, cb] = stops[i + 1];
    const t = (k - a) / (b - a);
    return ca.map((c, n) => Math.round(c + (cb[n] - c) * t));
  };

  const lab = document.querySelector('[data-ls-lab]');
  if (lab) {
    const range = lab.querySelector('input[type=range]');
    const sw = lab.querySelector('[data-ls-switch]');
    const name = lab.querySelector('[data-ls-name]');
    const use = lab.querySelector('[data-ls-use]');
    const board = lab.querySelector('[data-ls-kelvin]');
    const paint = () => {
      const k = Number(range.value);
      const rgb = mix(k).join(' ');
      lab.style.setProperty('--led', `rgb(${rgb})`);
      lab.style.setProperty('--glow', `rgb(${rgb} / 55%)`);
      const band = k <= 3300 ? 'warm' : k <= 5000 ? 'natural' : 'cool';
      name.textContent = name.dataset[band];
      use.textContent = use.dataset[band];
      dots(board, `${k}K`);
      range.setAttribute('aria-valuetext', `${k} K, ${name.textContent}`);
    };
    range.addEventListener('input', paint);
    sw.addEventListener('click', () => {
      const on = sw.getAttribute('aria-pressed') !== 'true';
      sw.setAttribute('aria-pressed', on);
      lab.classList.toggle('is-off', !on);
    });
    paint();
  }

  const khBand = (s) => (/warm/i.test(s) ? 'warm' : /natural|neutral/i.test(s) ? 'natural' : /cool|daylight|cold/i.test(s) ? 'cool' : '');
  const khKelvin = (spec, band) => {
    const n = (spec.match(/\d{4}/g) || []).map(Number).filter((x) => x >= 1800 && x <= 8000);
    return n.length ? n.reduce((a, b) => a + b, 0) / n.length : { warm: 3000, natural: 4000, cool: 6000 }[band];
  };
  document.addEventListener('click', (event) => {
    const open = event.target.closest?.('[data-ls-kh-open]');
    if (!open) return;
    const kh = open.closest('[data-ls-kh]');
    const fieldset = kh.previousElementSibling;
    const dlg = kh.querySelector('[data-ls-kh-dlg]');
    const box = dlg.querySelector('[data-ls-kh-choices]');
    const tip = dlg.querySelector('[data-ls-kh-tip]');
    const seen = new Set();
    const choices = [];
    fieldset.querySelectorAll('label').forEach((label) => {
      const input = label.querySelector('input');
      const name = label.querySelector('.variant-option__button-label__text')?.textContent.trim() || '';
      const colour = name.split(' - ')[0].trim();
      const band = khBand(colour);
      if (!input || !band || seen.has(colour)) return;
      seen.add(colour);
      const spec = label.querySelector('.ls-vx__spec')?.textContent.trim() || '';
      choices.push({ input, colour, band, spec, k: khKelvin(spec, band) });
    });
    if (!choices.length) return;
    let room = 'kitchen';
    let pick = choices.find((c) => c.input.checked) || choices[0];
    const paint = () => {
      dlg.style.setProperty('--led', `rgb(${mix(pick.k).join(' ')})`);
      dlg.querySelectorAll('[data-room]').forEach((svg) => {
        svg.toggleAttribute('hidden', svg.dataset.room !== room);
      });
      const tab = dlg.querySelector(`[data-ls-kh-room="${room}"]`);
      dlg.querySelectorAll('[data-ls-kh-room]').forEach((t) => t.setAttribute('aria-selected', t === tab));
      tip.textContent = tip.dataset[room];
      box.querySelectorAll('button').forEach((b, i) => {
        b.setAttribute('aria-pressed', choices[i] === pick);
        b.classList.toggle('is-usual', choices[i].band === tab.dataset.band);
      });
    };
    box.innerHTML = '';
    choices.forEach((c) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.style.setProperty('--sw', `rgb(${mix(c.k).join(' ')})`);
      b.innerHTML = '<i aria-hidden="true"></i><span></span><small></small><em></em>';
      b.querySelector('span').textContent = c.colour;
      b.querySelector('small').textContent = c.spec;
      b.querySelector('em').textContent = box.dataset.usual;
      b.addEventListener('click', () => {
        pick = c;
        paint();
      });
      box.append(b);
    });
    dlg.querySelectorAll('[data-ls-kh-room]').forEach((t) => {
      t.onclick = () => {
        room = t.dataset.lsKhRoom;
        paint();
      };
    });
    dlg.querySelector('[data-ls-kh-go]').onclick = () => {
      dlg.close();
      if (!pick.input.checked) pick.input.click();
    };
    dlg.querySelector('[data-ls-kh-close]').onclick = () => dlg.close();
    dlg.onclick = (e) => {
      if (e.target === dlg) dlg.close();
    };
    paint();
    dlg.showModal();
  });

  // Collection filters: (?) help on a filter name, and the phone drawer's More filters toggle.
  // Delegated so they keep working after the filters re-render.
  document.addEventListener('click', (e) => {
    const help = e.target.closest('.ls-fhelp');
    if (help) {
      e.preventDefault(); // the button sits in the filter's summary; don't fold the filter
      const note = document.getElementById(help.getAttribute('aria-controls'));
      if (!note) return;
      note.hidden = !note.hidden;
      help.setAttribute('aria-expanded', String(!note.hidden));
      if (!note.hidden) note.closest('details')?.setAttribute('open', '');
      return;
    }
    const more = e.target.closest('[data-ls-more-filters]');
    if (more) {
      const list = document.getElementById(more.getAttribute('aria-controls'));
      if (!list) return;
      list.hidden = !list.hidden;
      more.setAttribute('aria-expanded', String(!list.hidden));
    }
  });
})();
